const canonicalAmountPattern = /^[0-9]+(?:\.[0-9]{0,2})?$/;

const isCanonicalAmount = (value: string): boolean =>
  value.match(canonicalAmountPattern)?.[0] === value;

export const normalizeTransferAmount = (input: string): string | null => {
  let canonical = input.replace(/[ \u00a0\u202f]/g, '').replace(/,/g, '.');

  if (canonical === '') {
    return '';
  }

  if (canonical.startsWith('.')) {
    canonical = `0${canonical}`;
  }

  return isCanonicalAmount(canonical) ? canonical : null;
};

export const formatTransferAmountInput = (canonical: string): string => {
  const [integer, fraction] = canonical.split('.');
  const groupedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  return fraction === undefined ? groupedInteger : `${groupedInteger},${fraction}`;
};

const decimalIdentity = (canonical: string): string => {
  const [integer, fraction = ''] = canonical.split('.');
  const significantInteger = integer.replace(/^0+(?=\d)/, '');
  const significantFraction = fraction.replace(/0+$/, '');

  return significantFraction ? `${significantInteger}.${significantFraction}` : significantInteger;
};

export const parseTransferAmount = (canonical: string): number | null => {
  if (!isCanonicalAmount(canonical)) {
    return null;
  }

  const amount = Number(canonical);
  if (!Number.isFinite(amount)) {
    return null;
  }

  const serialized = JSON.stringify(amount);
  // Сравниваем десятичные строки: повторное Number скрыло бы потерю копеек.
  if (!isCanonicalAmount(serialized) || decimalIdentity(canonical) !== decimalIdentity(serialized)) {
    return null;
  }

  return amount;
};
